import { fabric as h } from "fabric";
const n = {}, j = ({
  maxLines: e,
  fontFamily: o,
  fontSize: r,
  fontStyle: x = "normal",
  fontWeight: c = 400,
  lineHeight: s = 1
}) => {
  const a = `box-height-${Object.values({
    maxLines: e,
    fontFamily: o,
    fontSize: r,
    fontStyle: x,
    fontWeight: c,
    lineHeight: s
  }).join("-")}`;
  let t = n[a];
  if (!t) {
    const i = Array(e).fill("Xg").join(`
`);
    t = new h.Textbox(i, {
      fontFamily: o,
      fontStyle: x,
      fontWeight: c,
      fontSize: r,
      lineHeight: s
    }).calcTextHeight(), n[a] = t;
  }
  return t;
};
export {
  j as getMaxBoxHeight
};
//# sourceMappingURL=index.es456.js.map
